import styled from 'styled-components';
import {
  CenteredSpaceWrap,
  SmallSectionHeader,
} from '../../../../CommonStyleUtils/dwebCommon.styles';
import ArrowLeftDetailsOneIcon from '../../../../../Icons/ArrowLeftDetailsOneIcon';

export const CaptivateTaggedHeaderWrap = styled(CenteredSpaceWrap)(
  props => `
    margin-bottom: -3.2rem;
    margin-top: ${props.theme.spacing.base};
  `,
);

export const RoundCircleWrapSpan = styled.span(
  props => `
    width:2rem;
    height:2rem;
    background-color:${props.theme.colors.goWhite.base};
    position:relative;
    align-items: center;
    border-radius:50%;
    margin-right:${props.theme.spacing.base};
`,
);

export const LeftArrowGalleryTraveller = styled(ArrowLeftDetailsOneIcon)(
  props => `
    width:1rem;
    height:1rem;
    fill:${props.theme.colors.downriver.base};
    position:absolute;
    top:0.5rem;
    right:0.5rem;
  `,
);

export const CaptivateHeaderText = styled(SmallSectionHeader)(
  props => `
    color:${props.theme.colors.goWhite.base};
    text-transform: capitalize;
  `,
);

export const CaptivateHeaderWrap = styled(CenteredSpaceWrap)(
  props => `
    margin-bottom: ${props.theme.spacing.custom(12)};
    margin-top: ${props.theme.spacing.base};
  `,
);

export const ViewMorePills = styled.div(
  props => `
    display:flex;
    align-items: center;
    cursor:pointer;
    color:${props.theme.colors.goWhite.base};
    font-weight: 600;
    font-size: ${props.theme.font.custom(14)};
    padding: ${props.theme.spacing.small} ${props.theme.spacing.custom(12)};
    background:${props.theme.colors.downriver.dark};
    border-radius:${props.theme.misc.borderRadius.custom(15.5)};
    margin-right: ${props.theme.spacing.large};
  `,
);
